import {
  ActionIcon,
  Button,
  Divider,
  Modal,
  SegmentedControl,
  Select,
  Skeleton,
  Table,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import React, { useEffect, useState, useRef } from "react";
import AWS from "aws-sdk/global";
import S3 from "aws-sdk/clients/s3";
import {
  getDepartmentListApi,
  getStandardObligations,
  getOrgDetailsFromMaster,
} from "../apis/userApis";
import {
  converDateToISO,
  convertToISO8601,
  getActFrequencyText,
  getRecFrequencyText,
} from "./utilities";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../redux/authSlice";
import {
  createObligationApi,
  getObligationsForAgreement,
} from "../apis/obligationApi";
import { getFile, getReadUrl, getAIAccessUrl } from "../apis/fileApi";
import { getCookiesSession } from "../cookiesSession";
import DocsLocker from "./DocsLocker";
import { IconPlus, IconMinus } from "@tabler/icons-react";
import axios from "axios";
import { getDocumentStatus, processDocument } from "../apis/extract";
import { showNotification } from "@mantine/notifications";
import { BarLoader } from "react-spinners";
import MasterObForAgreement from "../componenets/masterObForAgreement";

const LegacyAgreementForm2 = ({ setUiConfigs, details, view }) => {
  const [standardObligations, setStandardObligations] = useState(null);
  const [options, setOptions] = useState(["select"]);
  const [createobligation, setCreateObligation] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [agreementId, setAgreementId] = useState(0);
  const [obligations, setObligations] = useState(null);
  const [extractLoading, setExtractLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [extractClientDataLoading, setExtractClientDataLoading] =
    useState(false);
  console.log(details);
  const dispatch = useDispatch();
  const cookieData = JSON.parse(getCookiesSession("LawSignaUserDataMaster"));
  const userData = cookieData.user;
  //   const currentUrl = window.location.href;
  // console.log(currentUrl);
  console.log("details: ", details);
  const [url, setUrl] = useState(null);
  const [aiUrl, setAiUrl] = useState(null);
  const [mimeType, setMimeType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [connectObModal, setConnectObModal] = useState(false);
  useEffect(() => {
    const attachedFile = async () => {
      const response = await getFile({ id: details.agreementId });
      console.log("response: ", response);
      setFile(response.file);
    };
    attachedFile();
  }, [details.agreementId]);
  const getObligationsforAgreement = async () => {
    const response = await getObligationsForAgreement({
      agreementId: agreementId,
    });
    console.log(response);
    setObligations(response.obligations);
  };
  useEffect(() => {
    if (agreementId > 0) getObligationsforAgreement();
  }, [agreementId]);
  useEffect(() => {
    const getObligationsOptions = async () => {
      const response = await getStandardObligations();
      setStandardObligations(response.obligationData);
      if (response.obligationData.length > 0) {
        setOptions(response.outputArray);
      }
    };
    getObligationsOptions();
    const fetchDepartments = async () => {
      console.log("got in to this function");
      const response = await getDepartmentListApi();
      if (response.success) {
        const data = response.departments.map((item) => ({
          label: item.name,
          value: String(item.id),
        }));
        setDepartments(data);
      }
    };
    fetchDepartments();
  }, []);
  function getDepartment(department) {
    const dep = departments.find((d) => d.label === department);
    return dep ? dep.value : null;
  }
  const actFrequencyData = [
    { label: "one-time", value: "1" },
    { label: "on-going", value: "2" },
    { label: "recurring", value: "3" },
  ];
  const recFrequencyData = [
    { label: "weekly", value: "7" },
    { label: "fortnight", value: "14" },
    { label: "monthly", value: "30" },
    { label: "quarterly", value: "90" },
    { label: "half-yearly", value: "182" },
    { label: "annually", value: "365" },
  ];
  const reminderTimeData = [
    { label: "1-day", value: "1" },
    { label: "2-days", value: "2" },
    { label: "3-days", value: "3" },
    { label: "4-days", value: "4" },
    { label: "5-days", value: "5" },
    { label: "6-days", value: "6" },
    { label: "7-days", value: "7" },
    { label: "15-days", value: "15" },
    { label: "30-days", value: "30" },
    { label: "45-days", value: "45" },
    { label: "60-days", value: "60" },
    { label: "90-days", value: "90" },
  ];
  function getActFrequencyNumber(department) {
    const dep = actFrequencyData.find((d) => d.label === department);
    return dep ? Number(dep.value) : null;
  }

  const [obligationData, setObligationData] = useState({
    clNo: "",
    title: "",
    desc: "",
    actFrequency: null,
    recFrequency: 7,
    startDate: "",
    endDate: details.endDate,
    department: null,
    reminderTime: null,
    remarks: "",
    businessUnit: details.businessUnit,
    // mapRegion: details.mapRegion,
    mapRegion: 0,
    local: details.local,
    connectedAgreement: details.agreementId,
    connectedParty: details.secondParty,
    extraCol1: details.typeOfAgreement,
    createdBy: userData.name,
    createdId: userData.id,
    createdByEmail: userData.email,
    dependedOb: null, 
  });

  console.log(details);
  const drive = "https://drive.google.com/";

  // useEffect(() => {
  //   if (file) {
  //     const getPreviewUrl = async () => {
  //       const intialurl = file.hostedLink;
  //       if (intialurl.slice(0, 10) === drive.slice(0, 10)) {
  //         setUrl(intialurl);
  //         setLoading(false);
  //       } else {
  //         console.log("intialUrl = ", intialurl);
  //         setMimeType(file.mimeType);
  //         const key = file.extraCol1;
  //         const response = await getReadUrl({ hostedLink: file.hostedLink });
  //         if (response.success) {
  //           setUrl(response.signedUrl);
  //           setLoading(false);
  //         }
  //       }
  //     };
  //     getPreviewUrl();
  //   }
  // }, [file]);

  console.log("file: ", file);

  // useEffect(() => {
  //   if (file) {
  //     const getPreviewUrl = async () => {
  //       setLoading(true);
  //       const initialUrl = file.hostedLink;
  //       const drivePrefix = "https://drive.google.com/";

  //       // 1. Check if it's a Google Drive link (first 10 chars)
  //       if (initialUrl && initialUrl.slice(0, 10) === drivePrefix.slice(0, 10)) {
  //         setUrl(initialUrl);
  //         setLoading(false);
  //       } else {
  //         // 2. If not Drive, fetch the signed URL for S3
  //         try {
  //           const response = await getReadUrl({ hostedLink: file.hostedLink });
  //           if (response.success) {
  //             setUrl(response.signedUrl);
  //           }
  //           console.log(response.success, "response dsbiuehfeiufhisufj");

  //           const responseAi = await getAIAccessUrl({
  //             hostedLink: file.hostedLink,
  //           });
  //           if (responseAi.success) {
  //             setAiUrl(responseAi.signedUrl);
  //           }
  //           console.log(responseAi.success, "response ai ");
  //         } catch (error) {
  //           console.error("Failed to fetch signed URL", error);
  //         } finally {
  //           setLoading(false);
  //         }
  //       }
  //     };
  //     getPreviewUrl();
  //   }
  // }, [file]);
  useEffect(() => {
    if (file) {
      const getPreviewUrl = async () => {
        console.log("📁 File received:", file);

        setLoading(true);

        const initialUrl = file.hostedLink;
        const drivePrefix = "https://drive.google.com/";

        console.log("🔗 Initial URL:", initialUrl);

        // 1. Check if it's a Google Drive link
        const isGoogleDrive =
          initialUrl && initialUrl.slice(0, 10) === drivePrefix.slice(0, 10);

        console.log("📌 Is Google Drive URL:", isGoogleDrive);

        if (isGoogleDrive) {
          console.log("✅ Using direct Google Drive URL");

          setUrl(initialUrl);
          setLoading(false);
        } else {
          // 2. Fetch signed URLs for S3
          try {
            console.log("⏳ Fetching signed read URL...");

            const response = await getReadUrl({
              hostedLink: file.hostedLink,
            });

            console.log("📥 Read URL response:", response);

            if (response.success) {
              console.log("✅ Read signed URL set:", response.signedUrl);

              setUrl(response.signedUrl);
            } else {
              console.warn("⚠️ Failed to get read signed URL");
            }

            console.log("⏳ Fetching AI access URL...");

            const responseAi = await getAIAccessUrl({
              hostedLink: file.hostedLink,
            });

            console.log("🤖 AI URL response:", responseAi);

            if (responseAi.data.success) {
              console.log("✅ AI signed URL set:", responseAi.data.signedUrl);

              setAiUrl(responseAi.data.signedUrl);
            } else {
              console.warn("⚠️ Failed to get AI signed URL");
            }
          } catch (error) {
            console.error("❌ Failed to fetch signed URLs:", error);
          } finally {
            console.log("🏁 Loading finished");

            setLoading(false);
          }
        }
      };

      getPreviewUrl();
    } else {
      console.log("⚠️ No file provided");
    }
  }, [file]);

  const handleCreate = (newItem) => {
    const createdOption = { label: newItem, value: newItem };
    setOptions([...options, createdOption]);
    setObligationData({ ...obligationData, title: newItem });
    return createdOption;
  };

  function validate(data) {
    const keys = {};
    if (!data.clNo) {
      keys.clNo = "please fill clNo.";
    }
    if (!data.title) {
      keys.title = "please fill title";
    }
    if (!data.desc) {
      keys.desc = "please fill desc.";
    }
    if (!data.department) {
      keys.department = "please fill dept.";
    }
    if (!data.actFrequency) {
      keys.actFrequency = "fill act. freq.";
    }
    if (!data.startDate || new Date(data.startDate) > new Date(data.endDate)) {
      keys.startDate = "fill valid start Date";
    }
    if (data.actFrequency !== 1 && !data.recFrequency) {
      keys.recFrequency = "fill rec frequency";
    }
    if (!data.reminderTime) {
      keys.reminderTime = "fill reminder time";
    }
    if (Object.keys(keys).length) {
      showNotification({
        color: "red",
        title: "Service Record",
        message: "Make sure all fields are filled properly.",
      });
      setErrors(keys);
      return false;
    }
    return true;
  }
  const createNewObligation = async (data) => {
    if (validate(data)) {
      const response = await createObligationApi({ body: data });
      if (response.success) {
        console.log("obligation created");
        setCreateObligation(false);
        setObligationData({
          clNo: "",
          title: "",
          desc: "",
          actFrequency: 1,
          recFrequency: 7,
          startDate: "",
          endDate: details.endDate,
          department: 1,
          reminderTime: 1,
          remarks: "",
          businessUnit: details.businessUnit,
          mapRegion: details.mapRegion,
          local: details.local,
          connectedAgreement: details.agreementId,
          connectedParty: details.secondParty,
          extraCol1: details.typeOfAgreement,
          createdBy: userData.name,
          createdId: userData.id,
          createdByEmail: userData.email,
          dependedOb: null,
        });
      }
    }
  };
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    createNewObligation(obligationData);
  };
  const onAddObligation = async (e, obligation) => {
    e.preventDefault();
    console.log("obligation: ", obligation);
    const preparedData = {
      clNo: obligation.clNo,
      title: obligation.title,
      desc: obligation.desc,
      actFrequency: obligation.actFrequency,
      recFrequency: obligation.recFrequency,
      startDate: obligation.startDate,
      endDate:
        obligation.actFrequency === 1 ? obligation.endDate : details.endDate,
      department: obligation.department,
      reminderTime: obligation.reminderTime,
      remarks: "",
      businessUnit: details.businessUnit,
      local: details.local,
      connectedAgreement: details.agreementId,
      connectedParty: details.secondParty,
      extraCol1: details.typeOfAgreement,
      createdBy: userData.name,
      createdId: userData.id,
      createdByEmail: userData.email,
      dependedOb: obligation.dependedOb || null,
    };
    await createNewObligation(preparedData);
    const updated = obligations.filter((item) => item.id !== obligation.id);
    setObligations(updated);
    setDisabled(false);
  };
  const [expandedId, setExpandedId] = useState(null);
  const handleExpand = (id) => {
    setExpandedId(id); // Set the ID of the obligation to expand
  };
  console.log("obligation data: ", obligationData);
  const fetchPdfAsFile = async (signedUrl) => {
    const fileName = "document.pdf";
    try {
      const response = await fetch(signedUrl);

      if (!response.ok) {
        throw new Error("Failed to fetch the PDF.");
      }

      const blob = await response.blob();

      const file = new File([blob], fileName, { type: blob.type });
      return file;
    } catch (error) {
      console.error("Error downloading and converting PDF:", error);
      return null;
    }
  };

  // Function to extract counter party obligations from the document
  // This function will be called when the user clicks the "Extract Counter Client Obligations" button
  const extractData = async () => {
    setExtractLoading(true);

    try {
      console.log("obligation datssssa: ", obligationData.connectedParty);
      console.log("users data", userData.userOrgs.name);

      // Brand name for the counter party. Not present in the obligationData.
      const response = await processDocument({
        signedUrl: aiUrl + "?download=1",
        aggrementNum: agreementId,
        document_type: "ob_prompt",
        client_name: obligationData.connectedParty,
        brand_name: obligationData.connectedParty,
        file_extension: "pdf",
      });

      if (response?.task_id) {
        const taskId = response.task_id;
        let pollingAttempts = 0;
        const maxAttempts = 20; // e.g. stop after 2 minutes (40 * 3s)

        const pollingIntervalRef = setInterval(async () => {
          pollingAttempts++;

          if (pollingAttempts > maxAttempts) {
            clearInterval(pollingIntervalRef);
            showNotification({
              title: "Timeout",
              message: "Document processing timed out.",
              color: "red",
            });
            setExtractLoading(false);
            return;
          }

          try {
            const taskResponse = await getDocumentStatus({ taskId });
            console.log("Task response: ", taskResponse);

            switch (taskResponse.state) {
              case "SUCCESS":
                console.log("✅ Document processing completed successfully");
                showNotification({
                  title: "Success",
                  message: "Document processed successfully",
                  color: "green",
                });
                clearInterval(pollingIntervalRef);

                const transformedObligations =
                  taskResponse.result.result.obligations.map((item) => ({
                    id: Math.random().toString(36).substr(2, 9),
                    clNo: item.clauseNo,
                    title: item.clauseTitle,
                    desc: item.description,
                    actFrequency:
                      getActFrequencyNumber(item?.actionFrequency) || 1,
                    recFrequency: item?.recurrenceFrequency?.value || 7,
                    startDate: "",
                    endDate: null,
                    department: null,
                    reminderTime: 1,
                    remarks: "",
                    businessUnit: details?.businessUnit || null,
                    mapRegion: 0,
                    local: details?.local || null,
                    connectedAgreement: details?.agreementId || null,
                    connectedParty: details?.secondParty || null,
                    extraCol1: details?.typeOfAgreement || "",
                    createdBy: userData?.name || "",
                    createdId: userData?.id || "",
                    createdByEmail: userData?.email || "",
                  }));

                console.log(
                  "Transformed obligations: ",
                  transformedObligations
                );
                setObligations(transformedObligations);
                setExtractLoading(false);
                break;

              case "FAILURE":
                console.error("❌ Document processing failed");
                showNotification({
                  title: "Error",
                  message: "Failed to process document",
                  color: "red",
                });
                clearInterval(pollingIntervalRef);
                setExtractLoading(false);
                break;

              case "PENDING":
              case "PROGRESS":
              case "STARTED":
                console.log(
                  `ℹ️ Document processing status: ${taskResponse.state}`
                );
                break;

              default:
                console.warn(`⚠️ Unknown task state: ${taskResponse.state}`);
                break;
            }
          } catch (error) {
            console.error("Error checking task status:", error);
            clearInterval(pollingIntervalRef);
            showNotification({
              title: "Error",
              message: "Error while checking document status",
              color: "red",
            });
            setExtractLoading(false);
          }
        }, 10000); // Poll every 3 seconds
      } else {
        throw new Error("Document processing task ID not returned.");
      }
    } catch (err) {
      console.error(
        err?.response?.data?.error || err.message || "Processing error"
      );
      showNotification({
        title: "Error",
        message: err?.response?.data?.error || "Failed to process document",
        color: "red",
      });
      setExtractLoading(false);
    }
  };

  // Function to extract client obligations from the document
  // This function will be called when the user clicks the "Extract Client Obligations" button
  const extractClientData = async () => {
    setExtractClientDataLoading(true);

    try {
      // Brand name for the counter party.
      // If brand name is not available, use connectedParty as fallback
      let brandName = userData.userOrgs.name;

      // Fetch organization details to get the brand name
      const res = await getOrgDetailsFromMaster();
      if (res.success) {
        brandName = res.result[0].details?.brandName;
      } else {
        console.log("Failed to fetch organization details");
      }

      const response = await processDocument({
        signedUrl: aiUrl + "?download=1",
        aggrementNum: agreementId,
        document_type: "ob_prompt",
        client_name: userData.userOrgs.name,
        brand_name: brandName,
        file_extension: "pdf",
      });

      if (response?.task_id) {
        const taskId = response.task_id;
        let pollingAttempts = 0;
        const maxAttempts = 8; // e.g. stop after 2 minutes (40 * 3s)

        const pollingIntervalRef = setInterval(async () => {
          pollingAttempts++;

          if (pollingAttempts > maxAttempts) {
            clearInterval(pollingIntervalRef);
            showNotification({
              title: "Timeout",
              message: "Document processing timed out.",
              color: "red",
            });
            setExtractClientDataLoading(false);
            return;
          }

          try {
            const taskResponse = await getDocumentStatus({ taskId });
            console.log("Task response: ", taskResponse);

            switch (taskResponse.state) {
              case "SUCCESS":
                console.log("✅ Document processing completed successfully");
                showNotification({
                  title: "Success",
                  message: "Document processed successfully",
                  color: "green",
                });
                clearInterval(pollingIntervalRef);

                const transformedObligations =
                  taskResponse.result.result.obligations.map((item) => ({
                    id: Math.random().toString(36).substr(2, 9),
                    clNo: item.clauseNo,
                    title: item.clauseTitle,
                    desc: item.description,
                    actFrequency:
                      getActFrequencyNumber(item?.actionFrequency) || 1,
                    recFrequency: item?.recurrenceFrequency?.value || 7,
                    startDate: "",
                    endDate: null,
                    department: null,
                    reminderTime: 1,
                    remarks: "",
                    businessUnit: details?.businessUnit || null,
                    mapRegion: 0,
                    local: details?.local || null,
                    connectedAgreement: details?.agreementId || null,
                    connectedParty: details?.secondParty || null,
                    extraCol1: details?.typeOfAgreement || "",
                    createdBy: userData?.name || "",
                    createdId: userData?.id || "",
                    createdByEmail: userData?.email || "",
                  }));

                console.log(
                  "Transformed obligations: ",
                  transformedObligations
                );
                setObligations(transformedObligations);
                setExtractClientDataLoading(false);
                break;

              case "FAILURE":
                console.error("❌ Document processing failed");
                showNotification({
                  title: "Error",
                  message: "Failed to process document",
                  color: "red",
                });
                clearInterval(pollingIntervalRef);
                setExtractClientDataLoading(false);
                break;

              case "PENDING":
              case "PROGRESS":
              case "STARTED":
                console.log(
                  `ℹ️ Document processing status: ${taskResponse.state}`
                );
                break;

              default:
                console.warn(`⚠️ Unknown task state: ${taskResponse.state}`);
                break;
            }
          } catch (error) {
            console.error("Error checking task status:", error);
            clearInterval(pollingIntervalRef);
            showNotification({
              title: "Error",
              message: "Error while checking document status",
              color: "red",
            });
            setExtractClientDataLoading(false);
          }
        }, 10000); // Poll every 3 seconds
      } else {
        throw new Error("Document processing task ID not returned.");
      }
    } catch (err) {
      console.error(
        err?.response?.data?.error || err.message || "Processing error"
      );
      showNotification({
        title: "Error",
        message: err?.response?.data?.error || "Failed to process document",
        color: "red",
      });
      setExtractClientDataLoading(false);
    }
  };
  return (
    <>
      <div>
        {/* {file && url && mimeType && !loading && (
          <iframe
            src={url}
            type={mimeType}
            width="100%"
            height="400px"
            title="Agreement View"
          />
        )} */}
        <div style={{ marginBottom: "20px" }}>
          {loading ? (
            <Skeleton height={500} width="100%" radius="md" />
          ) : url ? (
            <iframe
              src={url}
              width="100%"
              height="500px"
              title="PDF Preview"
              style={{ border: "1px solid #eee", borderRadius: "8px" }}
            />
          ) : (
            <div
              style={{
                height: "200px",
                background: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text color="dimmed">Select a file to preview</Text>
            </div>
          )}
        </div>
        {/* {loading && <Skeleton width={"100%"} height={"400px"} />} */}
        <div className="flex justify-between">
          <Button onClick={() => setCreateObligation(true)} className="mt-2" variant="contained">
            Add Obligation
          </Button>
          <div className="gap-4">
            <Button
              disabled={extractClientDataLoading || extractLoading}
              className="mr-4"
              onClick={extractClientData}
              variant="outline"
            >
              My Obligations
            </Button>
            <Button
              disabled={extractClientDataLoading || extractLoading}
              className="mr-4"
              onClick={extractData}
              variant="contained"
            >
              Counter Party Obligations
            </Button>
            <Button onClick={() => setShowModal(true)} className="mt-2" variant="outline">
              Import Obligations
            </Button>
          </div>
        </div>
        {createobligation && (
          <>
            <div
              // onSubmit={(e) => onSubmitHandler(e)}
              className=" w-full flex flex-row gap-1 mt-4"
            >
              <TextInput
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                placeholder="clause no."
                label="clause no."
                className="text-center rounded-sm  w-1/12"
                value={obligationData.clNo}
                onChange={(e) =>
                  setObligationData({ ...obligationData, clNo: e.target.value })
                }
                error={errors.clNo && errors.clNo}
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                placeholder="title"
                label="title"
                className="text-center rounded-sm w-2/12"
                value={obligationData.title}
                data={options}
                searchable
                creatable
                getCreateLabel={(query) => `+ Add "${query}"`}
                onCreate={handleCreate}
                onChange={(val) => {
                  const selectedObligation = standardObligations.find(
                    (obligation) => obligation.title === val,
                  );
                  if (selectedObligation) {
                    setObligationData({
                      ...obligationData,
                      title: val,
                      desc: selectedObligation.desc,
                      actFrequency: selectedObligation.actFrequency,
                      recFrequency: selectedObligation.recFrequency,
                      department: selectedObligation.department,
                      reminderTime: selectedObligation.reminderTime,
                    });
                  }
                }}
                error={errors.title && errors.title}
              />
              <TextInput
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                value={obligationData.desc}
                placeholder="description"
                label="description"
                className="text-center rounded-sm w-2/12"
                onChange={(e) =>
                  setObligationData({ ...obligationData, desc: e.target.value })
                }
                error={errors.desc && errors.desc}
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                label="occurance type"
                className="text-center w-1/12"
                placeholder="select occurance type"
                data={actFrequencyData}
                value={
                  obligationData.actFrequency
                    ? String(obligationData.actFrequency)
                    : null
                }
                onChange={(val) =>
                  setObligationData({
                    ...obligationData,
                    actFrequency: val ? Number(val) : null,
                  })
                }
                error={errors.actFrequency && errors.actFrequency}
              />
              {obligationData.actFrequency !== 1 && (
                <Select
                  required
                  labelProps={{
                    sx: {
                      fontSize: ".75rem",
                  },
                }}
                  value={
                    obligationData.recFrequency
                      ? String(obligationData.recFrequency)
                      : null
                  }
                  label="rec. cycle"
                  className="text-center w-1/12"
                  placeholder="select rec. frequency"
                  data={recFrequencyData}
                  onChange={(val) =>
                    setObligationData({
                      ...obligationData,
                      recFrequency: val ? Number(val) : null,
                    })
                  }
                  error={errors.recFrequency && errors.recFrequency}
                />
              )}
              <DatePicker
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                value={obligationData.startDate}
                minDate={new Date()}
                label="start date"
                className="text-center w-1/12"
                placeholder="start date"
                onChange={(val) =>
                  setObligationData({
                    ...obligationData,
                    startDate: convertToISO8601(converDateToISO(val)),
                  })
                }
                error={errors.startDate && errors.startDate}
              />
              {obligationData.actFrequency === 1 && (
                <DatePicker
                  minDate={new Date()}
                  required
                  labelProps={{
                    sx: {
                      fontSize: ".75rem",
                    },
                  }}
                  label="end date"
                  className="text-center w-1/12"
                  placeholder="end date"
                  value={obligationData.endDate}
                  onChange={(val) =>
                    setObligationData({ ...obligationData, endDate: val })
                  }
                />
              )}
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                label="function"
                className="text-center w-1/12"
                placeholder="function"
                value={
                  obligationData.department
                    ? String(obligationData.department)
                    : null
                }
                data={departments}
                onChange={(val) =>
                  setObligationData({
                    ...obligationData,
                    department: val ? Number(val) : null,
                  })
                }
                error={errors?.department}
              />
              <Select
                required
                labelProps={{
                  sx: {
                    fontSize: ".75rem",
                  },
                }}
                label="reminder time"
                className="text-center w-1/12"
                placeholder="reminder time"
                value={
                  obligationData.reminderTime
                    ? String(obligationData.reminderTime)
                    : null
                }
                data={reminderTimeData}
                onChange={(val) =>
                  setObligationData({
                    ...obligationData,
                    reminderTime: val ? Number(val) : null,
                  })
                }
                error={errors?.reminderTime}
              />
              <Button
                onClick={(e) => onSubmitHandler(e)}
                className="mt-6 w-1/12"
                variant="outline"
              >
                Save
              </Button>

              <Button
                variant="contained"
                className="mt-6 w-1/12"
                onClick={() => setConnectObModal(true)}
              >
                Connect
              </Button>
            </div>
          </>
        )}
        {/* Table of extracted/imported obligations */}
        <div className="mt-2">
          {obligations && obligations.length > 0 && (
            <div className="overflow-x-auto overflow-y-auto max-h-96 border border-gray-300 rounded-lg">
              <div className="bg-gray-200 min-w-full">
                <div className="text-center">
                  <div className="text-center flex">
                    {/* <div className="w-1/12">select</div> */}
                    <div className="w-1/12">clause no.*</div>
                    <div className="w-2/12">obligation title*</div>
                    <div className="w-3/12">description*</div>
                    <div className="w-1/12">action frequency*</div>

                    <div className="w-1/12">start date*</div>
                    <div className="w-1/12">rec. frequency/end date*</div>
                    <div className="w-1/12">department*</div>
                    <div className="w-1/12">reminder time*</div>
                    <div>&nbsp;</div>
                  </div>
                </div>
                <div className="text-center">
                  {obligations &&
                    obligations.map((row, index) => (
                      <div className="flex" key={row.id}>
                        <div className="w-1/12">
                          <input
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.clNo ? "red" : undefined,
                              borderWidth:
                                row.isInvalid && !row.clNo ? 2 : undefined,
                            }}
                            required
                            className="p-1 "
                            type="text"
                            value={row.clNo}
                            onChange={(e) => {
                              const updated = [...obligations];
                              updated[index].clNo = e.target.value;
                              updated[index].isInvalid = false; // Reset invalid flag on change
                              setObligations(updated);
                            }}
                          />
                        </div>

                        {/* title textarea */}
                        <div className="w-2/12">
                          <textarea
                            required
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.title ? "red" : undefined,
                              borderWidth:
                                row.isInvalid && !row.title ? 2 : undefined,
                            }}
                            rows="3"
                            className="p1"
                            value={row.title}
                            onChange={(e) => {
                              const updated = [...obligations];
                              updated[index].title = e.target.value;
                              updated[index].isInvalid = false;
                              setObligations(updated);
                            }}
                          />
                        </div>

                        {/* desc textarea with expandable logic */}
                        <div className="w-3/12 text-center">
                          <textarea
                            required
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.desc ? "red" : undefined,
                              borderWidth:
                                row.isInvalid && !row.desc ? 2 : undefined,
                            }}
                            rows="3"
                            className="p-1 w-full"
                            value={row.desc}
                            onChange={(e) => {
                              const updated = [...obligations];
                              updated[index].desc = e.target.value;
                              updated[index].isInvalid = false;
                              setObligations(updated);
                            }}
                          />
                        </div>

                        {/* actFrequency text */}
                        <div className="w-1/12">
                          <Select
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.actFrequency
                                  ? "red"
                                  : undefined,
                              borderWidth:
                                row.isInvalid && !row.actFrequency
                                  ? 2
                                  : undefined,
                            }}
                            required
                            data={actFrequencyData}
                            value={
                              row.actFrequency ? String(row.actFrequency) : null
                            }
                            onChange={(val) => {
                              const updated = [...obligations];
                              updated[index].actFrequency = val
                                ? Number(val)
                                : null;
                              updated[index].isInvalid = false;
                              setObligations(updated);
                            }}
                            className="bg-white rounded border border-gray-300"
                          />
                        </div>

                        {/* Conditionally render either endDate input or recFrequency select */}

                        {/* startDate input */}
                        <div className="w-1/12">
                          <input
                            required
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.startDate
                                  ? "red"
                                  : undefined,
                              borderWidth:
                                row.isInvalid && !row.startDate ? 2 : undefined,
                            }}
                            type="date"
                            className="bg-white rounded border border-gray-300 px-2 py-1"
                            value={
                              row.startDate ? row.startDate.slice(0, 10) : ""
                            }
                            onChange={(e) => {
                              const updated = [...obligations];
                              updated[index].startDate = new Date(
                                e.target.value,
                              ).toISOString();
                              updated[index].isInvalid = false;
                              setObligations(updated);
                            }}
                          />
                        </div>
                        {row.actFrequency === 1 ? (
                          <div className="w-1/12">
                            <input
                              required
                              type="date"
                              className="bg-white rounded border border-gray-300 px-2 py-1"
                              min={
                                row.startDate ? row.startDate.slice(0, 10) : ""
                              }
                              value={
                                row.endDate ? row.endDate.slice(0, 10) : ""
                              }
                              style={{
                                width: "95%",
                                borderColor:
                                  row.isInvalid && !row.endDate
                                    ? "red"
                                    : undefined,
                                borderWidth:
                                  row.isInvalid && !row.endDate ? 2 : undefined,
                              }}
                              onChange={(e) => {
                                const updated = [...obligations];
                                updated[index].endDate = new Date(
                                  e.target.value,
                                ).toISOString();
                                updated[index].isInvalid = false;
                                setObligations(updated);
                              }}
                            />
                          </div>
                        ) : (
                          <div className="w-1/12">
                            <Select
                              style={{
                                width: "95%",
                                borderColor:
                                  row.isInvalid && !row.recFrequency
                                    ? "red"
                                    : undefined,
                                borderWidth:
                                  row.isInvalid && !row.recFrequency
                                    ? 2
                                    : undefined,
                              }}
                              required
                              data={recFrequencyData}
                              value={
                                row.recFrequency
                                  ? String(row.recFrequency)
                                  : null
                              }
                              onChange={(val) => {
                                const updated = [...obligations];
                                updated[index].recFrequency = val
                                  ? Number(val)
                                  : null;
                                updated[index].isInvalid = false;
                                setObligations(updated);
                              }}
                              className="bg-white rounded border border-gray-300 "
                            />
                          </div>
                        )}
                        {/* department name (not editable) */}
                        <div className="w-1/12">
                          <Select
                            required
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.department
                                  ? "red"
                                  : undefined,
                              borderWidth:
                                row.isInvalid && !row.department
                                  ? 2
                                  : undefined,
                            }}
                            placeholder="department"
                            value={
                              row.department ? String(row.department) : null
                            }
                            data={departments}
                            onChange={(value) => {
                              const updated = [...obligations];
                              updated[index].department = value
                                ? Number(value)
                                : null;
                              updated[index].isInvalid = false;
                              setObligations(updated);
                            }}
                            className="bg-white rounded border border-gray-300"
                          />
                        </div>

                        {/* reminderTime select */}
                        <div className="w-1/12">
                          <Select
                            required
                            style={{
                              width: "95%",
                              borderColor:
                                row.isInvalid && !row.reminderTime
                                  ? "red"
                                  : undefined,
                              borderWidth:
                                row.isInvalid && !row.reminderTime
                                  ? 2
                                  : undefined,
                            }}
                            value={
                              row.reminderTime
                                ? String(row.reminderTime)
                                : null
                            }
                            onChange={(value) => {
                              const updated = [...obligations];
                              updated[index].reminderTime = value
                                ? Number(value)
                                : null;
                              updated[index].isInvalid = false;
                              setObligations(updated);
                            }}
                            data={reminderTimeData}
                            className="bg-white rounded border border-gray-300"
                          />
                        </div>

                        {/* action icon */}
                        <div>
                          <div className="flex flex-row mr-4">
                            <ActionIcon
                              //disabled={disabled}
                              onClick={(e) => {
                                e.preventDefault();
                                const isValid =
                                  row.clNo &&
                                  row.title &&
                                  row.desc &&
                                  row.actFrequency &&
                                  row.startDate &&
                                  (row.endDate || row.recFrequency) &&
                                  row.department &&
                                  row.reminderTime;

                                if (!isValid) {
                                  showNotification({
                                    title: "Incomplete Fields",
                                    message:
                                      "Please fill out all mandatory fields before proceeding.",
                                    color: "red",
                                  });

                                  // Highlight invalid fields
                                  const updated = [...obligations];
                                  updated[index].isInvalid = true; // Add a flag for invalid rows
                                  setObligations(updated);
                                  return;
                                }

                                setDisabled(true);
                                onAddObligation(e, row);
                              }}
                              color="white"
                            >
                              <IconPlus size={24} />
                            </ActionIcon>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="flex flex-row justify-between">
          {view ? (
            <div></div>
          ) : (
            // <Button
            //   style={{
            //     backgroundColor: "#46BDE1",
            //   }}
            //   onClick={() => setUiConfigs({ currentStep: 0 })}
            //   className="mt-3"
            // >
            //   view agreement
            // </Button>
            <></>
          )}
          <Button
            onClick={() => setUiConfigs({ currentStep: 2 })}
            className="mt-3"
            variant="outline"
          >
            View Obligations
          </Button>
        </div>
      </div>
      <Modal
        opened={showModal}
        onClose={() => setShowModal(false)}
        size="calc(80vw)"
      >
        <DocsLocker
          showSelect={true}
          setAgreementId={setAgreementId}
          setShowModal={setShowModal}
        />
      </Modal>

      <Modal
        opened={connectObModal}
        onClose={() => setConnectObModal(false)}
        size="lg"
        title="Connect Master Obligation"
      >
        <MasterObForAgreement
          agreementId={agreementId || details.agreementId}
          dependedOb={obligationData.dependedOb}
          onSelectOb={(id) => {
            setObligationData((prev) => ({
              ...prev,
              dependedOb: id,
            }));
            setConnectObModal(false);
          }}
        />
      </Modal>

      {(extractClientDataLoading || extractLoading) && (
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
          style={{
            pointerEvents: "all",
            cursor: "wait",
            backdropFilter: "blur(2px)",
            WebkitBackdropFilter: "blur(2px)",
          }}
        >
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <BarLoader width={150} height={5} color="#30BEF5" />
            <p className="text-gray-600 mt-4 text-center">
              Processing document...
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default LegacyAgreementForm2;
